import React from 'react'
import PropTypes from 'prop-types'
import { Box, makeStyles } from '@material-ui/core'
import { Image, Transformation } from 'cloudinary-react'
import { CLOUDINARY_NAME } from '../../../../constants'
import {
    getCloudinaryPublicIdFromUrl,
    getCloudinarySmbEmbossOverlay,
    isCloudinaryUrl,
} from '../../../../utils/cloudinaryUtils'

const useStyles = makeStyles((theme) => ({
    outerWrapper: (props) => ({
        width: props.fullWidth ? '100%' : '40%',
        [theme.breakpoints.up('sm')]: {
            width: props.fullWidth ? '100%' : '25%',
        },
    }),
    container: {
        position: 'relative',
        width: '100%',
        paddingTop: '100%', // Square aspect ratio
    },
    imagesWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    bottomImage: {
        position: 'absolute',
        left: '0%',
        bottom: '7%',
        width: '85%',
        zIndex: 1,
    },
    topImage: {
        position: 'absolute',
        top: '4%',
        right: '5%',
        width: '70%',
        zIndex: 2,
        boxShadow: '2px 4px 8px rgba(0, 0, 0, 0.2)',
    },
}))

const boxImageUrl =
    'https://res.cloudinary.com/gift-card-granny/image/upload/c_thumb,w_200,g_face/GCG/smb_assets/box_of_cards.png'

const BoxSetWithCardImage = ({
    cardImageSrc,
    cardImageAlt,
    fullWidth = false,
    cardNetwork = null,
    cardType = null,
    embossName = true,
    withYourLogoHere = false,
    merchant = null,
    isGiftProgram = false,
    applyEmbossOverlay = true,
}) => {
    const classes = useStyles({ fullWidth })

    return (
        <div className={classes.outerWrapper}>
            <Box className={classes.container}>
                <div className={classes.imagesWrapper}>
                    <img
                        src={boxImageUrl}
                        alt="Gift card box"
                        className={classes.bottomImage}
                    />
                    {isCloudinaryUrl(cardImageSrc) ? (
                        <Image
                            cloudName={CLOUDINARY_NAME}
                            publicId={getCloudinaryPublicIdFromUrl(
                                cardImageSrc
                            )}
                            loading="lazy"
                            alt={cardImageAlt}
                            className={classes.topImage}
                        >
                            {applyEmbossOverlay && (
                                <Transformation
                                    rawTransformation={getCloudinarySmbEmbossOverlay(
                                        cardNetwork,
                                        cardType,
                                        embossName,
                                        withYourLogoHere,
                                        merchant,
                                        isGiftProgram
                                    )}
                                />
                            )}
                            <Transformation quality="auto" fetchFormat="auto" />
                        </Image>
                    ) : (
                        <img
                            src={cardImageSrc}
                            alt={cardImageAlt}
                            className={classes.topImage}
                        />
                    )}
                </div>
            </Box>
        </div>
    )
}

BoxSetWithCardImage.propTypes = {
    cardImageSrc: PropTypes.string.isRequired,
    cardImageAlt: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    cardNetwork: PropTypes.string,
    cardType: PropTypes.string,
    embossName: PropTypes.bool,
    withYourLogoHere: PropTypes.bool,
    merchant: PropTypes.shape({
        image: PropTypes.string,
    }),
    isGiftProgram: PropTypes.bool,
    applyEmbossOverlay: PropTypes.bool,
}

export default BoxSetWithCardImage
